import { RouterProvider } from "react-router-dom";
import { Router } from "./Router/Router";
import Alert, { AlertColor } from "@mui/material/Alert";
import { AppProvider } from "./ContextApi/AppProvider";
import {
  Snackbar,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
  Button,
} from "@mui/material";
import React from "react";
import { ServiceBase, SESSION_EXPIRED_EVENT } from "./Services/ServiceBase";
import { JwtAuth } from "./Models/JwtAuth";
import { jwtDecode } from "jwt-decode";
import { User } from "./Models/User";

export default function App() {
  const [open, setOpen] = React.useState(false);
  const [msg, setMsg] = React.useState('');
  const [severity, setSeverity] = React.useState<AlertColor>();
  const [token, setToken] = React.useState('');
  const [user, setUser] = React.useState<User | null>(null)
  const [jwtAuth, setJwtAuth] = React.useState<JwtAuth | null>(null);
  const [sessionExpiredOpen, setSessionExpiredOpen] = React.useState(false);
  const serviceBase = new ServiceBase();

  const handleClose = (
    event?: React.SyntheticEvent | Event,
    reason?: string
  ) => {
    if (reason === "clickaway") {
      return;
    }

    setOpen(false);
  };

  const setTokenOnServiceBase = (token: string) =>  {
    setToken(token);
    serviceBase.setToken(token);
    setJwtAuthDeserialize(token);
  }

  const setJwtAuthDeserialize = (jwtAuth: string) =>  {
    setJwtAuth(jwtDecode(jwtAuth));
    sessionStorage.setItem('jwtAuth', jwtAuth); 
  }

  const getToken = () => {
    return token;
  }

  const showMessage = (msg: string, open: boolean, severity: AlertColor) => {
    setOpen(true);
    setMsg(msg);
    setSeverity(severity);
  };

  const handleSessionExpiredConfirm = () => {
    setSessionExpiredOpen(false);
    window.location.href = "/";
  };

  React.useEffect(() => {
    const handleSessionExpired = () => {
      // Já estamos na tela de login: não exibe o popup nem redireciona de novo.
      if (window.location.pathname === "/") {
        return;
      }

      setSessionExpiredOpen(true);
    };

    window.addEventListener(SESSION_EXPIRED_EVENT, handleSessionExpired);
    return () =>
      window.removeEventListener(SESSION_EXPIRED_EVENT, handleSessionExpired);
  }, []);

  return (

    <AppProvider.Provider
      value={{
        showMessage: showMessage,
        setToken: setTokenOnServiceBase,
        getToken: getToken,
        setUser: setUser,
        jwtAuth: jwtAuth,
        user: user
      }}
      >
      <Snackbar open={open} autoHideDuration={6000} onClose={handleClose} anchorOrigin={{vertical: 'bottom', horizontal: 'right'}}>
        <Alert variant="filled" severity={severity}>
          {msg}
        </Alert>
      </Snackbar>

      <Dialog
        open={sessionExpiredOpen}
        onClose={handleSessionExpiredConfirm}
        disableEscapeKeyDown
      >
        <DialogTitle>Sessão expirada</DialogTitle>
        <DialogContent>
          <DialogContentText>
            Seu login expirou. Você será redirecionado para a tela de login.
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button variant="contained" onClick={handleSessionExpiredConfirm} autoFocus>
            Ir para o login
          </Button>
        </DialogActions>
      </Dialog>

        <RouterProvider router={Router} />
    </AppProvider.Provider>
  );
}
